import { ROLES_TYPE } from "./roles";

// export const FEATURES = {
//   MANUAL_SWAP: {
//     KEY: "manual",
//     SUB: {
//       INVENTORY: "inventory",
//       DIGITAL_TWIN: "digital_twin",
//       OTA: "ota",
//     },
//   },
//   BATTERY_MOVEMENT: {
//     KEY: "batteryMovement",
//   },
//   CASH_COLLECTION: {
//     KEY: "cash",
//   },
// };

export const FEATURES = {
  MANUAL_SWAP: ROLES_TYPE.MANUAL_SWAP,
  BATTERY_MOVEMENT: ROLES_TYPE.BATTERY_MOVEMENT,
  CASH_COLLECTION: ROLES_TYPE.CASH_COLLECTION,
};

export const SUB_FEATURES = {
  [FEATURES.MANUAL_SWAP]: [
    ROLES_TYPE.MANUAL_SWAP_DIGITAL,
    ROLES_TYPE.MANUAL_SWAP_INVENTORY,
    ROLES_TYPE.MANUAL_SWAP_OTA,
  ],
};
